import { useState } from "react";
import { PhoneNumberAdd } from "./PhoneNumberAdd";
import { PhoneNumberTable } from "./PhoneNumberTable";
import { CommunicationBindingDelete } from "../CommunicationBindingDelete";
import { Heading } from "V2.0/common/heading";

function PhoneNumberBinding(props) {
  const {
    isOpen,
    onClose,
    onBindingAdd,
    phoneNumbers,
    communicationBinding,
    onBindingConfirmDelete,
    onBindingDelete,
    locked
  } = props;

  return (
    <>
      <div className="flex flex-col min-w-[500px] w-1/3 mx-auto mt-4 p-4 gap-y-4 h-full min-h-0">
        <div className="w-full flex items-center justify-between">
          <Heading>Phone Numbers ({communicationBinding.length})</Heading>
          {!locked && <PhoneNumberAdd
            onPhoneNumberAdd={onBindingAdd}
            phoneNumbers={phoneNumbers}
          />}
        </div>
        <PhoneNumberTable
          communicationBinding={communicationBinding}
          onItemDelete={onBindingDelete}
          locked={locked}
        />
      </div>
      {isOpen && !locked && (
        <CommunicationBindingDelete
          open={true}
          onClose={onClose}
          title="Delete Phone Number"
          onDelete={onBindingConfirmDelete}
        />
      )}
    </>
  );
}

export { PhoneNumberBinding };
